import { render, staticRenderFns } from "./PopUpDetalleAccion.vue?vue&type=template&id=ee16d528&scoped=true"
import script from "./PopUpDetalleAccion.vue?vue&type=script&lang=js"
export * from "./PopUpDetalleAccion.vue?vue&type=script&lang=js"
import style0 from "./PopUpDetalleAccion.vue?vue&type=style&index=0&id=ee16d528&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee16d528",
  null
  
)

export default component.exports